var _desc, _defs, _rect, _rect2, _g, _path, _line, _g2, _g3, _text, _circle, _path2, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobpilot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "jpTitle"
  }, "JobPilot") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "jpTitle"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "jpDesc"
  }, "A paper plane flying through open sky, towing a banner with a resume file on it.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "jpSky",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7fc4f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dcefFB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "jpSun",
    cx: 0.85,
    cy: 0.12,
    r: 0.45
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff7d6",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff7d6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "jpSoft",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 6,
    stdDeviation: 7,
    floodColor: "#4a7fae",
    floodOpacity: 0.25
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    fill: "url(#jpSky)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    fill: "url(#jpSun)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 128,
    cy: 96,
    rx: 58,
    ry: 22
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 168,
    cy: 82,
    rx: 42,
    ry: 20
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92,
    cy: 84,
    rx: 34,
    ry: 16
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 672,
    cy: 330,
    rx: 64,
    ry: 24
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 716,
    cy: 316,
    rx: 44,
    ry: 20
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 632,
    cy: 318,
    rx: 36,
    ry: 17
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 420,
    cy: 66,
    rx: 46,
    ry: 16
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 452,
    cy: 56,
    rx: 30,
    ry: 13
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 96,
    cy: 330,
    rx: 44,
    ry: 16
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 126,
    cy: 320,
    rx: 30,
    ry: 13
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 388 C140 372 180 330 216 296 C240 274 268 268 276 288 C284 308 258 320 244 306 C230 292 244 258 282 234 C318 212 366 196 420 188",
    fill: "none",
    stroke: "#3a6ea8",
    strokeWidth: 3,
    strokeDasharray: "1 13",
    strokeLinecap: "round",
    opacity: 0.8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 512,
    y1: 196,
    x2: 580,
    y2: 226,
    stroke: "#3a6ea8",
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-8 470 180)",
    filter: "url(#jpSoft)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400 196 L540 152 L468 244 Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 196 L468 212 L468 244 Z",
    fill: "#c9dcee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540 152 L468 212 L468 244 Z",
    fill: "#e8f1f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 196 L540 152 L468 212 Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 196 L540 152 M468 212 L540 152",
    stroke: "#9dbdd8",
    strokeWidth: 2,
    fill: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#jpSoft)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M580 214 L748 206 L744 252 L576 260 Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580 214 L576 260 L562 250 L566 224 Z",
    fill: "#d5e5f2"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 662,
    y: 240,
    textAnchor: "middle",
    fontFamily: "Consolas, ui-monospace, monospace",
    fontSize: 17,
    fontWeight: 600,
    fill: "#17456e",
    transform: "rotate(-2 662 236)"
  }, "resume.pdf")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 738,
    cy: 222,
    r: 9,
    fill: "#34a56f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M734 222 L737 225 L743 218",
    stroke: "#ffffff",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 416,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', system-ui, sans-serif",
    fontSize: 32,
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#17456e"
  }, "Job"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#e8760c"
  }, "Pilot"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobpilot);
export default __webpack_public_path__ + "static/media/jobpilot.a51e2c27b03a34695747afae15ac1f40.svg";
export { ForwardRef as ReactComponent };